<div class="heading-component" style="width: 100%; height: 100%;">
    <h1 class="primary-color" color="primary">{{ heading }}</h1>
</div>
